import { Truck, Users, Route, FileText, Wrench, Fuel, LayoutDashboard, Receipt, ClipboardList } from "lucide-react";

const BASE_TABS = [
  { key: "tracking", label: "Tracking", Icon: Truck },
  { key: "drivers",  label: "Drivers",  Icon: Users },
  { key: "trips",    label: "Trips",    Icon: Route },
];

// Appended only for orgs on the Fleet Management tier — more tabs land here
// as later fleet modules (maintenance, fuel, alerts, dashboard) are built.
const FLEET_TABS = [
  { key: "documents",   label: "Documents",   Icon: FileText },
  { key: "maintenance", label: "Maintenance", Icon: Wrench },
  { key: "fuel",        label: "Fuel",        Icon: Fuel },
  { key: "expenses",    label: "Expenses",    Icon: Receipt },
  { key: "requests",    label: "Requests",    Icon: ClipboardList },
];

export default function FleetTabs({ activeTab, onChangeTab, isFleet, pendingRequestsCount = 0 }) {
  // Dashboard leads for fleet orgs — everything needing attention, in one place.
  const TABS = isFleet
    ? [{ key: "dashboard", label: "Dashboard", Icon: LayoutDashboard }, ...BASE_TABS, ...FLEET_TABS]
    : BASE_TABS;
  return (
    <div style={{
      flexShrink: 0, background: "#fff", borderBottom: "1px solid #E5E7EB",
      display: "flex", alignItems: "center", gap: 4, padding: "0 20px",
    }}>
      {TABS.map(({ key, label, Icon }) => {
        const active = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onChangeTab(key)}
            style={{
              display: "flex", alignItems: "center", gap: 6, position: "relative",
              background: "none", border: "none", cursor: "pointer",
              padding: "10px 4px", marginRight: 20,
              fontSize: 13.5, fontWeight: 600,
              color: active ? "#4F46E5" : "#6B7280",
              borderBottom: active ? "2px solid #4F46E5" : "2px solid transparent",
              transition: "color 0.15s, border-color 0.15s",
            }}
            onMouseOver={e => { if (!active) e.currentTarget.style.color = "#111827"; }}
            onMouseOut={e  => { if (!active) e.currentTarget.style.color = "#6B7280"; }}
          >
            <Icon size={14} />
            {label}
            {key === "requests" && pendingRequestsCount > 0 && (
              <span style={{
                background: "#DC2626", color: "#fff", fontSize: 10, fontWeight: 700,
                borderRadius: 99, minWidth: 16, height: 16, padding: "0 4px",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>{pendingRequestsCount > 9 ? "9+" : pendingRequestsCount}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
